<template lang="pug">
  .select-vendors-completed
    el-row
      el-col(:span="24")
        VendorBriefTableCompleted(:data="deliverVendorList")
</template>

<script>
import VendorBriefTableCompleted from './VendorBriefTableCompleted'
import axios from 'axios'

export default {
  components: {
    VendorBriefTableCompleted
  },
  data () {
    return {
      deliverVendorList: []
    }
  },
  mounted () {
    this.fetchDeliverVendorList()
  },
  methods: {
    fetchDeliverVendorList () {
      axios
        .get('/management/campaign/getDeliverVendorList', {
          params: {
            campaign_id: this.$store.state.campaign.id
          }
        })
        .then(res => {
          this.deliverVendorList = res.map(o => {
            return {
              ...o,
              selectUser: o.user[0]
            }
          })
        })
    }
  }
}
</script>
